import { EMAIL_TEMPLATE_FILTERS } from '../constants/contactFilterCategory'
import { notificationDangerCustomTime } from './customToastify'

export const validateContactFilters = (filters, values, filterCategory) => {
  if (
    filters['contact_effort_level'] ||
    filters['contact_grade'] ||
    filters['contact_assigned'] ||
    filters['contact_status']
  ) {
    if (!values['contact_division_id']) {
      notificationDangerCustomTime('Division filter field must be entered', 10000)
      return false
    }
  }
  if (filters['address_zip'] && filterCategory === EMAIL_TEMPLATE_FILTERS) {
    if (!values?.address_zip?.zip) {
      notificationDangerCustomTime('Zip code must be provided!', 2500)
      return false
    }
    if (!values?.address_zip?.distance_radius) {
      notificationDangerCustomTime('Distance Radius must be provided!', 2500)
      return false
    }
  }

  return true
}
